export const LIVLY_TOKEN =
  (process.env.REACT_APP_LIVLY_TOKEN as string) || 'livlyfe-token';

export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL as string;

export const nameSearchUrl = `${BASE_API_URL}/Residents/search`;
export const unitSearchUrl = `${BASE_API_URL}/property-units/search`;
export const sendNotificationUrl = `${BASE_API_URL}/notifications/send`;
export const getPropertyUrl = `${BASE_API_URL}/properties`;
